import React, { useState } from "react";
import Plus from "../../../../assets/svg/icons/common/Plus";
import Spinner from "../../../../components/Loaders/Spinner";
import Search from "../../../../components/SearchInput/SearchInput";
import Table from "../../../../components/Table";
import Button from "../../../../components/new-button";
import AddSubOrganizationModal from "./components/add-sub-organization-modal";
import useSubOrganizations from "./hooks/useSubOrganizations";
import styles from "./styles.module.scss";

const SubOrganizations = () => {
  const {
    subOrgs,
    searchTerm,
    handleSearchTextChange,
    loading,
    searchLoading,
  } = useSubOrganizations();
  const [addSubOrgModalOpen, setAddSubOrgModalOpen] = useState(false);

  const columns = [
    {
      field: "sub_org_name",
      headerName: "Sub-Organization Name",
      width: "200px",
      renderCell: (value, row) => (
        <div className={styles.nameCell}>{value}</div>
      ),
    },
    { field: "user_count", headerName: "Members", width: "100px" },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Search
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearchTextChange}
        />
        <Button
          variant="primary"
          icon={<Plus />}
          onClick={() => setAddSubOrgModalOpen(true)}
        >
          Add Sub Organization
        </Button>
      </div>

      {loading || searchLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "32px",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <div className={styles.tableWrapper}>
          <Table
            columns={columns}
            data={subOrgs}
            searching={searchTerm !== ""}
          />
        </div>
      )}

      <AddSubOrganizationModal
        open={addSubOrgModalOpen}
        onClose={() => setAddSubOrgModalOpen(false)}
      />
    </div>
  );
};

export default SubOrganizations;
